import createAxios from "./axiosHttp";

function getThirdCarriers(pagination, query, sort) {
  const axios = createAxios();
  const urlPath = "ttmm/third-carrier/ql";
  return axios.post(urlPath, { pagination, query, sort });
}

export const thirdCarrierService = {
  getThirdCarriers,
};
